// import { Base64 } from 'js-base64'
/**
 * 检测手机号
 */
export function testPhone (phone) {
  const phoneReg = new RegExp(/^1(3[0-9]|4[57]|5[0-35-9]|6[0-9]|7[01356789]|8[0-9]|9[0-9])\d{8}$/)

  return phoneReg.test(phone)
}


/**
 * 隐藏手机号部分
 */
export function encPhone (phone) {
  return phone.substr(0, 3) + '****' + phone.substr(-4)
}

/**
 * 匹配phone
 */
export function isPhone (str) {
  let reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
  return reg.test(str)
}

/**
 * 匹配Email地址
 */
export function isEmail (str) {
  if (str == null || str == '') return false
  var result = str.match(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
  if (result == null) return false
  return true
}

/**
 * 检测密码
 */
export function testPassword (pwd) {
  const pwdReg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/)

  return pwdReg.test(pwd)
}

/**
 * 检测身份证号
 */
export function testIdCard (idCard) {
  const idCardReg = new RegExp(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)

  return idCardReg.test(idCard)
}

/**
 * 检测银行卡号
 */
export function testBankCard (bankCard) {
  const bankCardReg = new RegExp(/^([1-9]{1})(\d{15}|\d{18})$/)

  return bankCardReg.test(bankCard)
}

/**
 * 真实名字
 */
export function testNickName (nickName) {
  const nickNameReg = new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9]+$/)

  return nickNameReg.test(nickName)
}

export function encRealName (realName) {
  return realName.substring(0, 1) + '**'
}

export function encIdCard (idCard) {
  return idCard.substring(0, 3) + '***************'
}

export function encBankCard (bankCard) {
  return bankCard.substring(0, 3) + '***********' + bankCard.substr(-4)
}

/**
 * 格式化时间
 */
export function formatTime (time = new Date()) {
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let day = time.getDate()
  let hour = time.getHours()
  let minute = time.getMinutes()
  let second = time.getSeconds()

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export function formatNumber (number) {
  return String(number).padStart(2, '0')
}

/**
 * 格式化金额
 */
export function formatMoney (money) {
  return Number(money).toFixed(2)
}

/**
 * 获取地址栏某字段
 */
export function GetQueryString (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 判斷是否微信
 */
export function isWeiXin () {
  let ua = window.navigator.userAgent.toLowerCase()
  /* eslint-disable */
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * 判断安卓及ios
 */
export function isIOS () {
  let browser = {
    versions: (function () {
        let u = navigator.userAgent
        return {// 移动终端浏览器版本信息
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile/i) || !!u.match(/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/), // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, // 是否iPad
          webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
        }
      }()
    ),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
  if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
    return true
  } else if (browser.versions.android) {
    return false
  }
}

/**
 * 获取ios系统的版本
 */
export function iosVersion () {
  let version = null
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('like mac os x') > 0) {
    let reg = /os [\d._]+/gi
    let v_info = ua.match(reg)
    version = (v_info + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.') //得到版本号9.3.2或者9.0
    version = parseInt(version.split('.')[0]) // 得到版本号第一位
    return version
  }
}

/**
 * 处理大数值
 */
export function formatNum (num) {
  if (parseInt(num) >= 100000000) {
    num = (parseInt(num) / 100000000).toFixed(2) + '亿'
  }
  if (parseInt(num) >= 10000) {
    num = (parseInt(num) / 10000).toFixed(2) + '万'
  }
  return num
}

/**
 * 对象按ASCII 排序 + base64加密
 */
// export function sortASCII (obj) {
//   let arr = new Array()
//   let num = 0
//   for (let i in obj) {
//     arr[num] = i
//     num++
//   }
//   let sortArr = arr.sort()
//   let sortObj = {}
//   for (let i in sortArr) {
//     sortObj[sortArr[i]] = obj[sortArr[i]]
//   }
//   let list = ''
//   for (let key in sortObj) {
//     list += key + '=' + sortObj[key] + '&'
//   }
//   list = list.substring(0, list.length - 1)
//   console.log(list)
//   return Base64.encode(list)
// }
